var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.400391,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32.4004C20.2435 32.4004 24.3131 30.7147 27.3137 27.7141C30.3143 24.7135 32 20.6439 32 16.4004C32 12.1569 30.3143 8.08726 27.3137 5.08668C24.3131 2.0861 20.2435 0.400391 16 0.400391C11.7565 0.400391 7.68687 2.0861 4.68629 5.08668C1.68571 8.08726 0 12.1569 0 16.4004C0 20.6439 1.68571 24.7135 4.68629 27.7141C7.68687 30.7147 11.7565 32.4004 16 32.4004ZM13.414 10.9864C13.0368 10.6221 12.5316 10.4205 12.0072 10.425C11.4828 10.4296 10.9812 10.6399 10.6104 11.0108C10.2395 11.3816 10.0292 11.8832 10.0247 12.4076C10.0201 12.932 10.2217 13.4372 10.586 13.8144L13.172 16.4004L10.586 18.9864C10.395 19.1709 10.2426 19.3916 10.1378 19.6356C10.033 19.8796 9.97781 20.142 9.9755 20.4076C9.97319 20.6731 10.0238 20.9365 10.1244 21.1823C10.2249 21.4281 10.3734 21.6514 10.5612 21.8392C10.749 22.027 10.9723 22.1755 11.2181 22.276C11.4639 22.3766 11.7272 22.4272 11.9928 22.4249C12.2584 22.4226 12.5208 22.3674 12.7648 22.2626C13.0088 22.1578 13.2295 22.0054 13.414 21.8144L16 19.2284L18.586 21.8144C18.9632 22.1787 19.4684 22.3803 19.9928 22.3757C20.5172 22.3712 21.0188 22.1608 21.3896 21.79C21.7605 21.4192 21.9708 20.9176 21.9753 20.3932C21.9799 19.8688 21.7783 19.3636 21.414 18.9864L18.828 16.4004L21.414 13.8144C21.7783 13.4372 21.9799 12.932 21.9753 12.4076C21.9708 11.8832 21.7605 11.3816 21.3896 11.0108C21.0188 10.6399 20.5172 10.4296 19.9928 10.425C19.4684 10.4205 18.9632 10.6221 18.586 10.9864L16 13.5724L13.414 10.9864Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.b3a4373981e921bb8b987f80f6539379.svg";
export { ForwardRef as ReactComponent };